module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/movix-417fa4fff76292e8764031ee6aa89df3.png";